import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function utilizationRequestStatusReducer(
  state = InitialState.utilizationRequestStatuses,
  action
) {
  switch (action.type) {
    case types.LOAD_UTILIZATIO_REQUEST_STATUSES_SUCCESS:
      return action.statuses;
    default:
      return state;
  }
}
